import Vue from 'vue'
import Router from 'vue-router'

import Wrap from '../view/component/Wrap.vue'
import Login from '../view/account/Login'
import Home from '../view/home/Home'
import Myunit from '../view/unitmanage/myunit.vue'
import Addunit from '../view/unitmanage/addunit.vue'
import EditunitBurst from '../view/unitmanage/editunit.vue'
import Editunit from '../view/unitmanage/editunit.vue'
import unitdetail from '../view/unitmanage/unit.vue'
import Registry from '../view/account/Registry'
import Forget from '../view/account/Forget'
import Burst from '../view/burst/Burstplan.vue' // 突发预案
import Weather from '../view/weather/Weatherplan.vue' // 天气预案
import FillingProgress from '../view/weather/fillingProgress.vue' // 天气预案
import FillingInfo from '../view/weather/fillingInfo.vue' // 天气预案之后
import FillingInfoBefore from '../view/weather/filingBefore.vue' // 天气预案之前
import Record from '../view/weather/Record.vue'
import User from '../view/account/User.vue'
import Modpwd from '../view/account/Modifypwd.vue'
import Step from '../view/weather/Step.vue'
import GovStep from '../view/weather/GovStep.vue'
import ConfirmInfo from '../components/weather/confirmInfo.vue'
import ComfirmFile from '../components/weather/comfirmFile.vue'
import BurstGovStep from '../view/burst/burstGovStep.vue'
import BurstParkStep from '../view/burst/burstParkStep.vue'
import BurstWtStep from '../view/burst/burstWtStep.vue'
import BurstOtherStep from '../view/burst/burstOtherStep.vue'
import Entdetail from '../../src/components/weather/entDetail.vue'
import BurstRecord from '../../src/view/burst/BurstRecord.vue'
import BurstStep from '../../src/view/burst/BurstStep.vue'
import BurstfillInfo from '../../src/view/burst/BurstfillInfo.vue'
import Filedwed from '../view/weather/filedwed.vue'
import Filedwedd from '../view/weather/filewedd.vue'
import notFind from '../view/component/notFind.vue'

import Guidefile from '@/view/manage/guidefile/guidefile.vue'
import expertController from '@/view/manage/expert/expertControllerList.vue'

Vue.use(Router)
export default new Router({
  /**
   * 配置路由，数组
   * 每个链接都是一个对象
   * 链接路径
   * 链接名称
   * 组件模板
   */
  routes: [{
      path: '/login',
      name: 'login',
      isShow: true,
      component: Login
    },
    {
      path: '/registry',
      name: 'registry',
      isShow: true,
      component: Registry
    },

    {
      path: '/forget',
      name: 'forget',
      isShow: true,
      component: Forget
    },
    {
      path: '/home',
      name: 'home',
      isShow: true,
      component: Home
    },
    {
      path: '/',
      component: Wrap,
      meta: {
        title: '突发环境事件应急预案',
        icon: 'iconfont icon-yuan',
        isRendering: [0, 1, 2, 3, 4]
      },
      children: [{
          path: '/',
          component: BurstRecord,
          isShow: true,
          meta: {
            title: '突发环境事件应急预案',
            isRendering: [0, 1, 2, 3, 4]
          },
          children: [{
              path: '/',
              component: BurstRecord,
              isShow: true,
              meta: {
                title: '突发备案指南',
                isRendering: [0, 1, 2, 3, 4]
              }
            }
          ]
        },
        {
          path: '/FillingInfo',
          component: FillingInfoBefore,
          isShow: true,
          meta: {
            title: '备案信息',
            isRendering: [0, 1, 2, 3, 4]
          }
        },
        {
          path: '/burstinfo',
          component: BurstfillInfo,
          isShow: true,
          meta: {
            title: '突发备案信息',
            isRendering: [0, 1, 2, 3, 4]
          }
        },
        {
          path: '/Filedwed/filing',
          name: 'FillingProgress',
          component: FillingProgress,
          isShow: true,
          meta: {
            title: '备案进度',
            isRendering: [0, 1, 2, 3, 4]
          }
        },
        {
          path: '/burststep',
          component: BurstStep,
          isShow: true,
          meta: {
            title: '突发备案进度',
            isRendering: [0, 1, 2, 3, 4]
          }
        },
        // {
        //   path: '/step',
        //   name: 'step',
        //   isShow: true,
        //   component: Step,
        //   meta: {
        //   }
        // },
        // {
        //   path: '/govstep',
        //   name: 'govstep',
        //   isShow: true,
        //   component: GovStep,
        //   meta: {
        //     title: '确认申报信息'
        //   }
        // },
        {
          path: '/burstgovstep',
          name: 'burstgovstep',
          isShow: true,
          component: BurstGovStep,
          meta: {
            title: '政府确认申报信息'
          }
        },
        {
          path: '/burstparkstep',
          name: 'burstparkstep',
          isShow: true,
          component: BurstParkStep,
          meta: {
            title: '工业园区确认申报信息'
          }
        },
        {
          path: '/burstwtstep',
          name: 'burstwtstep',
          isShow: true,
          component: BurstWtStep,
          meta: {
            title: '水源地确认申报信息'
          }
        },
        {
          path: '/burstotherstep',
          name: 'burstotherstep',
          isShow: true,
          component: BurstOtherStep,
          meta: {
            title: '其他企业确认申报信息'
          }
        },

        {
          path: '/editunitinburst',
          name:'Editunitinburst',
          component: EditunitBurst,
          isShow: true,
          meta: {
            title: '修改详情'
          }
        },
        
        // {
        //   path: '/entdetail',
        //   name: 'entdetail',
        //   isShow: true,
        //   component: Entdetail,
        //   meta: {
        //     title: '企业确认申报信息'
        //   }
        // }
      ]
    },

    {
      path: '/Weatherplan',
      component: Wrap,
      meta: {
        // title: '重污染天气应急预案',
        icon: 'iconfont icon-yuan',
        isRendering: [0, 1]
      },
      children: [{
          path: '/Weatherplan',
          component: Record,
          meta: {
            title: '重污染天气应急预案',
            isRendering: [0, 1]
          },
          children: [{
              path: '/',
              name: 'record',
              isShow: true,
              component: Record,
              meta: {
                title: '重污染备案指南'
              },
            },
          ]
        },
        {
          path: '/step',
          name: 'step',
          isShow: true,
          component: Step,
          meta: {
            title: '企业确认申报信息'
          }
        },
        {
          path: '/govstep',
          name: 'govstep',
          isShow: true,
          component: GovStep,
          meta: {
            title: '政府确认申报信息'
          }
        },
        // {
        //   path: '/burstgovstep',
        //   name: 'burstgovstep',
        //   isShow: true,
        //   component: BurstGovStep,
        //   meta: {
        //     title: '政府确认申报信息'
        //   }
        // },
        // {
        //   path: '/burstparkstep',
        //   name: 'burstparkstep',
        //   isShow: true,
        //   component: BurstParkStep,
        //   meta: {
        //     title: '工业园区确认申报信息'
        //   }
        // },
        // {
        //   path: '/burstwtstep',
        //   name: 'burstwtstep',
        //   isShow: true,
        //   component: BurstWtStep,
        //   meta: {
        //     title: '水源地确认申报信息'
        //   }
        // },
        // {
        //   path: '/burstotherstep',
        //   name: 'burstotherstep',
        //   isShow: true,
        //   component: BurstOtherStep,
        //   meta: {
        //     title: '其他企业确认申报信息'
        //   }
        // },
        {
          path: '/entdetail',
          name: 'entdetail',
          isShow: true,
          component: Entdetail,
          meta: {
            title: '企业确认申报信息'
          }
        }
      ]
    },

    {
      path: '/myunit',
      component: Wrap,
      meta: {
        title: '申报单位',
        icon: 'iconfont icon-danwei',
        isRendering: [0, 1, 2, 3, 4]
      },
      children: [{
        path: '/myunit',
        component: Myunit,
        meta: {
          title: '单位管理',
          isRendering: [0, 1, 2, 3, 4]
        }
      }, {
        path: '/addunit',
        component: Addunit,
        isShow: true,
        meta: {
          title: '添加单位'
        }
      }, {
        path: '/unitdetail',
        component: unitdetail,
        isShow: true,
        meta: {
          title: '单位详情'
        }
      }, {
        path: '/editunit',
        component: Editunit,
        isShow: true,
        meta: {
          title: '修改详情'
        }
      }]
    },
    {
      path: '/manage/guidefile',
      component: Wrap,
      meta: {
        title: '法律法规',
        icon: 'iconfont icon-icon-test',
        isRendering: [0, 1, 2, 3, 4]
      },
      children: [    {
        path: '/manage/guidefile',
        component: Guidefile,
        meta: {
          title: '法律法规',
          isRendering: [0, 1, 2, 3, 4]
        }
      },]
    },
    {
      path: '/expert/list',
      component: Wrap,
      meta: {
        title: '专家库',
        icon: 'iconfont icon-icon-test',
        isRendering: [0, 1, 2, 3, 4]
      },
      children: [    {
        path: '/expert/list',
        component: expertController,
        meta: {
          title: '专家库',
          isRendering: [0, 1, 2, 3, 4]
        }
      },]
    },
    {
      path: '/user',
      component: Wrap,
      meta: {
        title: '账号',
        icon: 'iconfont icon-icon-test',
        isRendering: [0, 1, 2, 3, 4]
      },
      children: [{
        path: '/user',
        component: User,
        meta: {
          title: '个人资料',
          isRendering: [0, 1, 2, 3, 4]
        }
      }, {
        path: '/modpwd',
        component: Modpwd,
        isShow: true,
        meta: {
          title: '修改密码'
        }
      }]
    },
    {
      path: '*',
      component: notFind,
      isShow: true,
      meta: {
        title: '404未找到',
      },
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js